import { useCallback } from "react";
import { Capacitor } from "@capacitor/core";
import { Haptics, ImpactStyle } from "@capacitor/haptics";
import { useWebHaptics } from "web-haptics/react";

// Haptic feedback that fires real native taps (Taptic Engine via the Capacitor
// Haptics plugin) inside the app shell, and falls back to the `web-haptics` tap
// simulation on the web.
export function useHaptics() {
  const { trigger: webTrigger } = useWebHaptics();
  const isNative = Capacitor.isNativePlatform();

  // A single tap — e.g. sending a message or sharing/hiding photos.
  const simpleTrigger = useCallback(() => {
    if (isNative) {
      void Haptics.impact({ style: ImpactStyle.Medium });
      return;
    }
    void webTrigger([{ duration: 25 }], { intensity: 0.7 });
  }, [isNative, webTrigger]);

  // A double tap, like a heartbeat — used when favoriting a profile.
  const favoritedTrigger = useCallback(() => {
    if (isNative) {
      void Haptics.impact({ style: ImpactStyle.Light });
      window.setTimeout(
        () => void Haptics.impact({ style: ImpactStyle.Heavy }),
        90,
      );
      return;
    }
    void webTrigger([
      { duration: 30 },
      { delay: 60, duration: 40, intensity: 1 },
    ]);
  }, [isNative, webTrigger]);

  return { simpleTrigger, favoritedTrigger };
}
